module.exports = __webpack_public_path__ + "img/zhgg.7ac1f6a5.png";